export const enum PropertySavedStatechartStoreActionEnum {
  addToLocalStorage = 'addToLocalStorage',
  sendSaveRequest = 'sendSaveRequest',
  removeFromLocalStorage = 'removeFromLocalStorage',
  sendUnsaveRequest = 'sendUnsaveRequest',
}
